import SectionHeading from "./SectionHeading";
import { testimonials } from "@/mocks/doujinshi";

const conceptImage =
  "https://readdy.ai/api/search-image?query=cozy%20illustration%20of%20a%20warm%20reading%20corner%20with%20a%20shelf%20full%20of%20anime%20comic%20books%20and%20art%20albums%2C%20lamp%20glow%2C%20cup%20of%20tea%2C%20collected%20and%20organized%2C%20warm%20terracotta%20and%20cream%20palette%2C%20stylized%20art&width=1000&height=760&seq=about-01&orientation=landscape";

const conceptPoints = [
  {
    icon: "ri-stack-fill",
    title: "按格式打包",
    text: "漫画本、画集、四格、条漫、短篇各自归档，整部作品打包成合集，一次点开全部可见。",
  },
  {
    icon: "ri-archive-line",
    title: "收藏友好",
    text: "专为喜欢收藏和翻阅的读者设计，无需到处找资源，登录后可建立自己的收藏书架。",
  },
  {
    icon: "ri-slideshow-line",
    title: "整本阅读",
    text: "从第一话到最新一话连贯呈现，省去逐章下载的麻烦，随时随地接着上次继续看。",
  },
];

export default function About() {
  return (
    <section id="about" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="关于典藏站"
        title="让收藏同人志，变成一件轻松的事"
        desc="我们相信好的同人作品值得被认真整理与呈现，而不是散落在各处难以寻找。"
      />

      <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-12">
        <div className="relative overflow-hidden rounded-lg">
          <img
            src={conceptImage}
            alt="同人志典藏站：温暖舒适的阅读与收藏角落"
            className="h-[360px] w-full object-cover object-top md:h-[440px]"
          />
          <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-md bg-accent-500 px-3 py-1.5 text-xs text-background-50">
            <i className="ri-archive-fill"></i>
            3830+ 部打包作品
          </span>
        </div>

        <div>
          <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            一次整本看完，从此告别找资源的烦恼
          </h3>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            同人志典藏站将海量同人内容按照你熟悉的格式与题材精心归档，把零散的单话、单图整理成
            完整的打包合集。无论你钟爱漫画本的剧情、画集的色彩、四格的轻松、条漫的连贯，还是短篇合集的多元，
            这里都能让你一键进入、整本畅读。
          </p>

          <div className="mt-6 space-y-4">
            {conceptPoints.map((p) => (
              <div key={p.title} className="flex gap-4 rounded-lg border border-background-200/70 bg-background-50 p-4">
                <span className="grid h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-lg text-secondary-700">
                  <i className={p.icon}></i>
                </span>
                <div>
                  <h4 className="font-label text-base text-foreground-950">{p.title}</h4>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-14">
        <h3 className="mb-6 text-center font-heading text-lg font-bold text-foreground-950 md:text-xl">
          读者怎么说
        </h3>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((r) => (
            <figure
              key={r.id}
              className="flex flex-col rounded-lg border border-background-200/70 bg-background-100/50 p-5"
            >
              <div className="flex gap-0.5 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-xs"></i>
                ))}
              </div>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                “{r.text}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className="grid h-9 w-9 items-center justify-center rounded-full bg-primary-100 font-label text-sm text-primary-700">
                  {r.name.slice(0, 1)}
                </span>
                <div>
                  <div className="text-sm font-medium text-foreground-950">{r.name}</div>
                  <div className="text-xs text-foreground-500">{r.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}